import { render } from "./aboutUsModel.vue?vue&type=template&id=4b3868e4"
import script from "./aboutUsModel.vue?vue&type=script&lang=js"
export * from "./aboutUsModel.vue?vue&type=script&lang=js"

import "./aboutUsModel.vue?vue&type=style&index=0&id=4b3868e4&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__